import React from 'react';
import { DateInput, DateInputProps } from 'react-admin';

const SmartDateInput = (props: DateInputProps) => {
  const { inputProps, ...rest } = props;

  const enhancedInputProps = {
    max: '9999-12-31',
    ...inputProps,
  };

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <DateInput {...rest} inputProps={enhancedInputProps} />;
};

export default SmartDateInput;
